import React, {useRef, useEffect} from 'react'
import { Helmet } from 'react-helmet';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'; 
import quoteImg from "../../assets/trainerAssests/quotes.png"
import { useLocation } from "react-router-dom";
import video from "../../assets/trainerAssests/Justin/JustinVideo.MOV"


function Justin() {
    const location = useLocation();
    const elementRef = useRef(null);

    useEffect(
        function () {
            if (location.pathname === "/ourtrainers/trainer/Justin") {
                elementRef.current.scrollIntoView({
                    behavior: "smooth",
                });
            }
        },
        [location]
    );
  return (
      <>
          <header className="trainerHeader justinHeader" ref={elementRef}>
              <div className="wrapper">
                  <div className="trainerHeaderText">
                      <h1>Meet Justin</h1>
                      <p>A PLTFRMPRO Trainer</p>
                      <button className="trainerContactButton">
                          <a href="mailto: justinkonik@gmail.com)">
                              Contact Justin
                          </a>
                      </button>
                  </div>
              </div>
          </header>
          <Helmet>
              <title>Find a Trainer Near Me | JUSTIN | PLTFRM</title>

              <meta
                  name="description"
                  content="Justin strive to educate his clients as much as possible so they can learn to be their own coaches. His goal is to get you started on your journey, educate you, and give you the confidence to make your own decisions. He focuses on building autonomy, competence and confidence."
              />
          </Helmet>
          <section className="getToKnow">
              <div className="wrapper">
                  <h2>Get to Know Justin...</h2>
                  <div className="trainerBio">
                      <img
                          className="trainerQuotes"
                          src={quoteImg}
                          alt="quotes"
                      />
                      <div className="bioText">
                          <p>
                              My name is Justin, I am a registered kinesiologist
                              and UofT grad. I swam competitively for 14 years
                              with the opportunity to swim internationally and
                              represent Canada for two of those years. I love
                              being active, and am competitive. I like to think
                              of myself as a well rounded person, always
                              considering mental, physical, emotional and
                              cognitive well being. I have faced my own
                              intersectional forms of oppression and privilege,
                              and am very cognizant of how others with different
                              intersectional identities may face other or
                              similar experiences. I find that fitness and
                              exercise offers some form to escape some of our
                              realities while helping to form and build
                              community.
                          </p>
                          <p>
                              I have been a high performance athlete all my life
                              having represented Canada in swimming. I love
                              exercising and just want to share my passion and
                              build a community. In my practice as a swim coach
                              for masters athletes I saw a large deficit in
                              training specifically in the ageing population,
                              arguably the cohort that needs it the most. I
                              think many people don’t think exercise is for them
                              and are afraid to try. I’m passionate about
                              teaching everyone to learn how to move their own
                              bodies to help expand their health span.
                          </p>
                      </div>
                  </div>
              </div>
          </section>

          <section className="trainerVideo">
              <div className="wrapper">
                  <video
                      src={video}
                      playsInline
                      controls
                      preload="auto"
                      type="video/mp4"
                      id="blogVideo"
                      title="Tisha Henry"
                  ></video>
              </div>
          </section>

          <section className="qualifications">
              <div className="wrapper">
                  <h2>Qualifications</h2>
                  <p>Bachelors of kinesiology</p>
                  <p>Registered kinesiologist</p>
                  <p>National coaching certification (NCCP level 2:swimming)</p>
                  <p>Bonefit level 1 (for osteoporosis) NLS, SFA</p>
              </div>
          </section>
          <section className="quotes">
              <div className="wrapper">
                  <div className="quoteContainer quote1">
                      <h3>#1 Training Advice for People</h3>
                      <p>
                          “Don’t worry about being perfect. Worry about getting
                          started.”
                      </p>
                  </div>
                  <div className="quoteContainer quote2">
                      <h3>What do you love about fitness?</h3>
                      <p>
                          “I love that there is always room to grow and learn in
                          fitness as there are so many different ways to move. I
                          love that with each step you take in your fitness
                          journey your life is impacted in many other facets.”
                      </p>
                  </div>
              </div>
          </section>
          <section className="trainerSocials">
              <div className="wrapper">
                  <h2 className="h2FormLink">
                      <Link to="/workoutform">Contact Justin</Link>
                  </h2>
                  <div className="trainerSocialsContainer">
                      <a
                          href="mailto: justinkonik@gmail.com"
                          className="iconCircle"
                      >
                          <FontAwesomeIcon
                              icon={faEnvelope}
                              className="fa-fw"
                          />
                          <span className="sr-only">Email Icon</span>
                      </a>
                  </div>
              </div>
          </section>
      </>
  );
}

export default Justin